import { http } from './http'
import { i18n } from '@/translations/i18n'
import { punctToSlash } from '@/helper'

export default {
  // Create Read Update Delete methods
  createItem(target, data) {
    return http.post(punctToSlash(target), data, {
      params: {
        locale: i18n.formatedLocale,
      },
    })
  },
  getItems(target, params) {
    return http.get(punctToSlash(target), {
      params: {
        locale: i18n.formatedLocale,
        ...params,
      },
    })
  },
  getItem(target, params) {
    return this.getItems(target, params)
  },
  editItem(target, params) {
    return http.put(punctToSlash(target), {
      locale: i18n.formatedLocale,
      ...params,
    })
  },
  deleteItem(target, data, params) {
    return http.delete(punctToSlash(target), {
      data,
      params: {
        ...params,
      },
    })
  },

  // this methods calls the CRUD methods
  // this methods are only create to better understand a method logic
  getLinkPreview(url) {
    return this.getItem('media.preview', { url })
  },
  getFilters(type) {
    return this.getItems(`${type}.filters`, { type })
  },
  getItemFilters(target, id) {
    return this.getItems(`${target}.${id}.filters`)
  },
  searchItems(target, params) {
    return this.getItems(target, params)
  },
  filterItems(target, filters) {
    return this.createItem(target, filters)
  },
  filterItem(target, filters) {
    return this.createItem(target, filters)
  },
}
